import { ReactNode } from 'react';
import { Skeleton } from '@/components/ui/skeleton';

interface ParagraphProps {
  children: ReactNode;
  className?: string;
  skeletonWidth?: string;
  skeletonHeight?: string;
}

export function Paragraph({
  children,
  className = "text-lg text-primary-600 dark:text-primary-400",
  skeletonWidth = "w-48",
  skeletonHeight = "h-6"
}: ParagraphProps) {
  // Show skeleton if children is null, undefined, or empty string
  const showSkeleton = children == null || children === '';

  if (showSkeleton) {
    return (
      <div className={className}>
        <Skeleton className={`block rounded ${skeletonWidth} ${skeletonHeight}`} />
      </div>
    );
  }

  return (
    <p className={className}>
      {children}
    </p>
  );
}

Paragraph.displayName = 'Paragraph';